module.exports = __webpack_public_path__ + "img/play_custom.eca9864b.png";